export default __webpack_public_path__ + "static/media/NewsPage.963b9709.gif";